export const mapObjectInArray = <A extends any[], E extends A[number], K extends keyof E>(
  array: A,
  matchFn: (el: E, index: number) => boolean,
  mapFn: (el: E) => E,
) => array.map((el, i) => (matchFn(el, i) ? mapFn(el) : el));
